// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4kby4","titleBlock":"styles_titleBlock__S01pc","title":"styles_title__1l07V"};